// extracted by mini-css-extract-plugin
export var root = "DFcF";
export var rootButton = "M70P";
export var rootImage = "ozrp";
export var rootPicture = "_82sz";
export var rootPictureLabel = "h77w";
export var rootPictureLabelWrapper = "C0Wq";
export var rootPictureWrapper = "m1Yl";
export var rootProduct = "_8zFU";
export var rootProductPrice = "gJOe";
export var rootProductPriceRegular = "f1DM";
export var rootProductPriceSale = "S-fX";
export var rootProductPriceWrapper = "hEeM";
export var rootProductRating = "u4Oi";
export var rootProductRatingValue = "gthr";
export var rootProductStar = "_9ri+";
export var rootProductStarFilled = "G7Uu";
export var rootProductStarIcon = "IwPS";
export var rootProductStars = "A0fh";
export var rootProductTitle = "PNWe";
export var rootTileLink = "J4lA";
export var rootWrapper = "VieG";